import Vue from 'vue'
import { instances } from '../core'
import { version } from 'axios/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.http = {}
Vue.$app.http.version = version
Vue.$app.http.instances = instances
